import { styled } from "@mui/system";
import Box from "@mui/material/Box";
export const AgencyBannerStyle = styled(Box)(({ theme }) => {
    return {
        "&#logo-icon-header": {
            display: "flex",
            justifyContent: "center",
            paddingTop: 10,
            paddingBottom: 5
        }
    };
});
